import { atom, useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import { useMemo } from "react";
import { useSwiper, useSwiperSlide } from "swiper/react";
import { audio_click, audio_move_page } from "../../lib/SoundManager";

const font = {
  fontFamily: "esamanru-Light",
};

const arrow = {
  ...font,
  fontSize: "40px",
  cursor: "pointer",
  fontFamily: "unset",
};

const defaultStatus = atom({
  key: "default",
  default: false,
});

const defaultGuideStatus = atom({
  key: "refreshGuide",
  default: {
    display: false,
    target: "",
  },
});

export default function App({ rootSwiper, color, tag = "", isRefresh = false, refreshStatus, refreshGuideStatus }) {
  const swiper = useSwiper();
  const swiperSlide = useSwiperSlide();

  let tempRefreshStatus;
  let tempRefreshGuide;
  if (!refreshStatus) {
    tempRefreshStatus = defaultStatus;
    tempRefreshGuide = defaultGuideStatus;
  } else {
    tempRefreshStatus = refreshStatus;
    tempRefreshGuide = refreshGuideStatus;
  }
  // console.log(tempRefreshGuide);
  const [refrsh, setRefresh] = useRecoilState(tempRefreshStatus);
  const [refreshGuide, setRefreshGuide] = useRecoilState(tempRefreshGuide);
  // const refreshGuideDefault = useResetRecoilState(tempRefreshGuide);

  if (!rootSwiper || (refreshGuide.target !== "" && refreshGuide.target !== tag)) {
    return <></>;
  }

  let isFirst = swiper.realIndex === 0 ? true : false;
  let isLast = swiper.realIndex === swiper.slides.length - 1 ? true : false;

  if (swiper.isVertical()) {
    isFirst = true;
    isLast = true;
  }

  if (swiper.isHorizontal()) {
    if (isFirst) {
      rootSwiper.allowTouchMove = true;
      rootSwiper.mousewheel.enable();
    } else {
      rootSwiper.allowTouchMove = false;
      rootSwiper.mousewheel.disable();
    }
  }

  if (!rootSwiper.support.touch) {
    rootSwiper.allowTouchMove = false;
  }

  const isHomeEnable = swiper.isVertical() || (swiper.isHorizontal() && swiper.isBeginning);

  const isRootPrevEnable =
    !rootSwiper.isBeginning && ((swiper.isHorizontal() && swiper.isBeginning) || swiper.isVertical());

  const isRootNextEnable = !rootSwiper.isEnd && ((swiper.isHorizontal() && swiper.isBeginning) || swiper.isVertical());

  const onClickRootPrev = () => {
    if (isRootPrevEnable) {
      rootSwiper.slidePrev();
    }
  };
  const onClickRootNext = () => {
    if (isRootNextEnable) {
      rootSwiper.slideNext();
    }
  };
  const onClickPrev = () => {
    if (!isFirst && swiper.isHorizontal()) {
      // audio_click();
      swiper.slidePrev();
      audio_move_page();
    }
  };

  const onClickNext = () => {
    if (!isLast && swiper.isHorizontal()) {
      // audio_click();
      swiper.slideNext();
      audio_move_page();
    }
  };

  const onClickRefersh = () => {
    console.log("onClickRefersh");
    if (refreshStatus) setRefresh(!refrsh);
  };

  if (!swiperSlide.isActive) {
    return <></>;
  }

  const onClickHome = () => {
    if (isHomeEnable) {
      rootSwiper.mousewheel.enable();
      rootSwiper.slideTo(0);
    }
  };

  const colorChanger = (c_name) => {
    if (c_name == "white") {
      return "#ffffff";
    } else if (c_name == "blue") {
      return "#001b54";
    } else {
      return "#ffffff";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        position: "fixed",
        width: "80px",
        // left: "10px",
        zIndex: 1,
        height: "100%",
        marginLeft: "-160px",
        // marginTop: "-63px",
        paddingTop: "186px",
      }}
    >
      <img src={`images/navi/${color}/logo.png`} style={{ objectFit: "none", height: "114px" }}></img>
      <div
        style={{
          ...font,
          color: colorChanger(color),
          fontSize: "30px",
          marginTop: "36px",
          fontWeight: "bolder",
          fontFamily: "esamanru-Bold",
        }}
        title="현재 페이지 번호"
      >
        {rootSwiper.realIndex}
      </div>
      <img style={{ marginTop: "13px", objectFit: "none" }} src={`images/navi/${color}/line1.png`}></img>
      <div
        style={{
          ...font,
          color: colorChanger(color),
          fontSize: "30px",
          marginTop: "10px",
          fontWeight: "lighter",
          opacity: "0.6",
        }}
        title="총 페이지 번호"
      >
        {rootSwiper.slides.length - 1}
      </div>
      <div
        style={{
          display: "flex",
          marginTop: "-12px",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <div
          style={arrow}
          className={isFirst ? `opacity1_${color}` : `opacity0_${color}`}
          onClick={onClickPrev}
          title="노란색 화살표를 클릭하면 해당 방향에 페이지가 있음"
        >
          ◀
        </div>
        <div>
          <div
            style={arrow}
            onClick={onClickRootPrev}
            className={isRootPrevEnable ? `opacity0_${color}` : `opacity1_${color}`}
            title="노란색 화살표를 클릭하면 해당 방향에 페이지가 있음"
          >
            ▲
          </div>
          <div style={{ ...arrow, fontSize: "24px" }} className={`navi-circle-${color}`}>
            ●
          </div>
          <div
            style={arrow}
            onClick={onClickRootNext}
            className={isRootNextEnable ? `opacity0_${color}` : `opacity1_${color}`}
            title="노란색 화살표를 클릭하면 해당 방향에 페이지가 있음"
          >
            ▼
          </div>
        </div>
        <div
          style={arrow}
          className={isLast ? `opacity1_${color}` : `opacity0_${color}`}
          onClick={onClickNext}
          title="노란색 화살표를 클릭하면 해당 방향에 페이지가 있음"
        >
          ▶
        </div>
      </div>
      <img
        style={{
          marginTop: "12px",
          objectFit: "none",
          cursor: "pointer",
          width: "31px",
          height: "34px",
          alignSelf: "center",
        }}
        className={isHomeEnable ? `opacity0_${color}` : `opacity1_${color}`}
        onClick={onClickHome}
        src={`images/navi/${color}/home.png`}
        title="첫 화면으로 돌아가기"
      />
      <img
        style={{
          marginTop: "12px",
          objectFit: "none",
          cursor: "pointer",
          width: "30px",
          height: "34px",
          alignSelf: "center",
          opacity: `${isRefresh ? 1 : 0.1}`,
        }}
        onClick={onClickRefersh}
        src={`images/navi/${color}/refresh.png`}
        title="리셋해서 다시 활동하기"
      />

      <img
        id="refresh_guide"
        style={{
          position: "absolute",
          top: "625px",
          left: "55px",
          display: refreshGuide.display ? "block" : "none",
        }}
        src="images/navi/refresh_bubble.png"
        title="처음부터 다시 해보기"
      />
    </div>
  );
}
